import { BaseDto } from './base.dto';

export class HonorificTitleDto extends BaseDto {
    // id: number;
    honorificTitle: string; // Attempt to join "employee" page, with "honorificTitle" table.
  }